import { ApiRoute } from 'config';
import { SubscriptionContext, ContextValue } from 'contexts/Subscription';
import createUseContextHook from './createUseContextHook';

const useSubscription = createUseContextHook<ContextValue>(
  // @ts-expect-error TODO: fix null safety
  SubscriptionContext,
  ApiRoute.SUBSCRIPTION,
);

export default useSubscription;
